import { SkyDialog, SkyText } from "@skypointcloud/skypoint-ui";
import { PRODUCTION_PROMPT_TEST_ID } from "../useProductionSwitchPrompt";

interface NonProductionWarningModalProps {
  currentInstanceName: string;
  productionInstanceName: string;
  onSwitch: () => void;
  onDismiss: () => void;
}

export function NonProductionWarningModal({
  currentInstanceName,
  productionInstanceName,
  onSwitch,
  onDismiss,
}: NonProductionWarningModalProps) {
  return (
    <SkyDialog
      open={true}
      onOpenChange={(open) => {
        if (!open) onDismiss();
      }}
      title="Heads Up!"
      testId={PRODUCTION_PROMPT_TEST_ID}
      primaryAction={{ label: "Go to Production", onClick: onSwitch }}
      secondaryAction={{ label: "Stay Here", onClick: onDismiss }}
    >
      <SkyText size={300}>
        You're currently in <strong>{currentInstanceName}</strong>. Want to switch to{" "}
        <strong>{productionInstanceName}</strong>?
      </SkyText>
    </SkyDialog>
  );
}
